import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import {
  addTaskStatus,
  clearTaskStatus,
  clearRedirect
} from "./ducks/actions";
import Form from "./form";
import Onboarding from "../../../shared/onboarding/onboarding";

function AddTaskStatus(props) {
  const filmId = props.filmId || props.match.params.filmId;

  const { addTaskStatus,
    visualEffect,
    errors,
    uploadImagesAndSaveTaskStatus,
    setName,
    name,
    embedded,
    clearTaskStatus,
    onCloseForm,
    redirect,
    onboardingSteps
  } = props;

  useEffect(() => {
    clearTaskStatus();
  }, []);

  useEffect(() => {
    if (name) {
      setName(name);
    }
  }, [name]);


  if (redirect) {
    if (props.redirect.to === "list") {
      props.clearRedirect();
      const url = `/films/${filmId}/task-statuses/`;
      return <Redirect to={url} />;
    }
  }

  function onAddTaskStatus(prop) {
    const files = prop.pictures || [];
    if (files && files.length > 0) {
      uploadImagesAndSaveTaskStatus(prop, files, true, filmId);
    } else {
      if (!prop.imageUrls) {
        prop.imageUrls = [];
      }
      addTaskStatus(filmId, prop);
    }
  }

  return (
    <ScrollIntoView
      className="blade-content widest"
      path="/films/:filmId/task-statuses/add"
      loading={false}>
      <Form
        errors={errors}
        propId={null}
        initialValues={visualEffect}
        loading={false}
        onSubmit={onAddTaskStatus}
        onCloseForm={onCloseForm}
        {...props}
        mode="add"
        reduxFormValues={props.reduxFormValues}
      />
      <Onboarding onboardingSteps={onboardingSteps} section="Task Status" />
    </ScrollIntoView>
  );
}

function mapStateToProps(state) {
  const { taskStatusesState } = state;
  const { rootState } = taskStatusesState;

  return {
    onboardingSteps: rootState.onboardingSteps,
    taskStatus: rootState.taskStatus,
    errors: rootState.errors,
    redirect: rootState.redirect
  };
}

export default connect(mapStateToProps, {
  addTaskStatus,
  clearTaskStatus,
  clearRedirect,

})(AddTaskStatus);
